export class RegistrationData {
  password = '';
  passwordConfirm = '';
  emailAddress = '';
}
